"use strict";

var templateCtx = require.context('./templates', true, /\.less$/);
var typesCtx = require.context('./types', true, /\.less$/);

var styles = {};

templateCtx.keys().reduce(function (obj, key) {
    obj[key.replace(/(.*\/)?(.*)\.less$/, '$2')] = templateCtx(key);
    return obj;
}, styles);

typesCtx.keys().reduce(function (obj, key) {
    obj[key.replace(/(.*\/)?(.*)\.less$/, '$2')] = typesCtx(key);
    return obj;
}, styles);


module.exports = styles;


/** WEBPACK FOOTER **
 ** ./src/style.js
 **/